import styled from "styled-components";
import Search from "./Search";
import { Button, ButtonDisabled } from "./Button";
import { useNavigate } from "react-router-dom";
import useListView from "shared/hooks/useListView";
import Refresh from "./Refresh";
import Modal from "./Modal";
import LoadingWithProgressBar from "./Loading";
import { hw, scrollbar } from "features/homework/homeworkUi";


interface ListViewProps{
    title?:string,
    clickedItem:string,
    setClickedItem:React.Dispatch<React.SetStateAction<string>>
    table:string,
    searchField:string
}


const ListView = ({title, clickedItem, setClickedItem, table, searchField}:ListViewProps)  => {
    const navigate = useNavigate();
    const {onRefreshClick, showList, search, onChange, fileRef, onFileChangeHandler, isOpenModal, modal, onModalCloseClickHandler, isLoading, loading} = useListView(table, clickedItem, clickedItem, setClickedItem, searchField);
    return(
        <Container>
            {isLoading ? <LoadingWithProgressBar title={"계정 생성중"} subTitle="데이터 베이스 동기화..." progress={loading}/> : null}
            <Modal isOpen={isOpenModal} title={modal.title} content={modal.content} onConfirm={modal.onClick} onClose={onModalCloseClickHandler}/>
            <Header>
                <div>
                    <Title>{title} 목록</Title>
                    <Sub>이름을 눌러 계정을 선택하세요.</Sub>
                </div>
                <Refresh onRefreshClick={onRefreshClick}/>
            </Header>
            <Search placeholder={`${title} 이름을 입력해 주세요`} value={search} onChange={onChange}/>
            <List>
                {showList()}
            </List>
            <Buttons>
                {title === "학생" ? <File type="file" ref={fileRef} onChange={onFileChangeHandler}/> : null}
                {clickedItem ? <ButtonDisabled name="수정하기" onButtonClick={() => navigate("register", {state:clickedItem})}/> : null}
                <Button name="생성하기" onButtonClick={() => navigate("register")}/>
            </Buttons>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
    min-height: 0;
    height: 100%;
    padding: 20px 18px 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
`
const List = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    border-radius: 12px;
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    overflow-y: auto;
    overflow-x: hidden;
    ${scrollbar}
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Sub = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
`


const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 12px;
    border-top: 1px solid ${hw.border};
    flex-shrink: 0;
`


const File = styled.input`
    display: none;
`
export default ListView;
